export var popoverDriver = function (documentWrapper) {
    return documentWrapper.$('.Popover');
};
export var createUncontrolledPopoverDriver = function (wrapper) {
    var popoverTriggerBase = wrapper.$(".popover-clickable-body-container");
    var popoverBodyDriver = popoverDriver(wrapper);
    return {
        openPopover: function () { return popoverTriggerBase.click(); },
        popoverBodyDriver: popoverBodyDriver,
        popoverTriggerBase: popoverTriggerBase,
    };
};
//# sourceMappingURL=driver.js.map